import { observer } from "mobx-react-lite"
import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import gsap from 'gsap';
import { ReactComponent as Plus } from "../../images/icons/plus.svg";
import { ReactComponent as Minus } from "../../images/icons/minus.svg";

const Clicker = ({ value, setValue, step, max, min, isDecimal, disabled }) => {
    const [width, setWidth] = useState(0);
    const [isFocus, setFocus] = useState(false);
    const span = useRef(null);

    useEffect(() => {
        setWidth(span.current.offsetWidth);
    }, [value]);
    const changeValue = (isPlus) => {
        let newValue = Number(value);
        if (isPlus) {
            if (max) newValue = (newValue+step) <= max ? newValue+step : newValue;
            else newValue = newValue + step;
        } else {
            if (min) newValue = (newValue-step) >= min ? newValue-step : newValue;
            else newValue = (newValue-step) >= 0 ? newValue-step : 0;
        }
        setValue(isDecimal ? Math.round(Number(newValue)) : Number(newValue).toFixed(1));
    }

    return (
        <div className={ isFocus ? "clicker focus" : "clicker"}>
            <button className="minus" onClick={() => !disabled && changeValue(false)}><Minus/></button>
            <div className="hide" ref={span}>{value}</div>
            <input type="number" disabled={disabled ? true : false} style={{ width }} value={value} onChange={(event) => {
                let newValue = event.target.value;
                if (newValue < 0) newValue = 0;
                if (max && newValue > max) newValue = max;
                setValue(isDecimal ? Math.round(Number(newValue)) : Number(newValue).toFixed(1));
            }} onFocus={() => setFocus(true)} onBlur={() => setFocus(false)}/>
            <button className="plus" onClick={() => !disabled && changeValue(true)}><Plus/></button>
        </div>
    )
}

export default observer(Clicker);
